export var ReminderItemType;
(function (ReminderItemType) {
    ReminderItemType[ReminderItemType["TERMIN"] = 0] = "TERMIN";
    ReminderItemType[ReminderItemType["AUFGABE"] = 1] = "AUFGABE";
})(ReminderItemType || (ReminderItemType = {}));
